import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';

const EmbeddedScripts = () => {
  const {
    serverConfig: { embeddedScripts },
    user
  } = useReduxState();

  const router = useRouter();

  const createScript = ({
    innerHTML,
    src
  }: {
    innerHTML?: string;
    src?: string;
  }) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    if (innerHTML) script.innerHTML = innerHTML;
    if (src) script.src = src;

    return script;
  };

  useEffect(() => {
    let validScripts = [] as HTMLScriptElement[];

    if (!document || !embeddedScripts?.length) return;
    else {
      const loggedUser = Boolean(user);
      const userIsAdmin = user?.roles?.includes('admin') || false;
      const userIsSuperadmin = user?.roles?.includes('superadmin') || false;

      validScripts = embeddedScripts
        .map((embeddedScript) => {
          if (!embeddedScript.enabled || !embeddedScript.content) return null;

          const isValidPath =
            !embeddedScript.limitToPage ||
            new RegExp(embeddedScript.limitToPage).test(router.pathname);
          if (!isValidPath) return null;

          const isValidUser =
            !embeddedScript.limitToRole ||
            (embeddedScript.limitToRole === 'logged' && loggedUser) ||
            (embeddedScript.limitToRole === 'admin' && userIsAdmin) ||
            (embeddedScript.limitToRole === 'superadmin' && userIsSuperadmin);
          if (!isValidUser) return null;

          const { content, type } = embeddedScript;

          return createScript({
            ...(type === 'code' ? { innerHTML: content } : {}),
            ...(type === 'url' ? { src: content } : {})
          });
        })
        .filter((script) => script);

      validScripts.forEach((script) => {
        document.head.appendChild(script);
      });
    }

    return () => {
      validScripts.forEach((script) => {
        document.head.removeChild(script);
      });
    };
  }, [embeddedScripts, router?.pathname, user?.roles]);

  return null;
};

export default EmbeddedScripts;
